module.exports = __webpack_public_path__ + "img/incident-detail-show-section.28e4a866.svg";